import { createContext } from "react";

interface PageContextProps {
    useGrid: boolean;
    isPreview?: boolean;
    isModulePreview?: boolean;
}

export const PageContext = createContext<PageContextProps>({
    useGrid: false,
    isPreview: false,
    isModulePreview: false,
});
